// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"275":"8e56d42cb7573b6d","464":"01fa4f50e22dcee9"}[chunkId] + ".js";
};